import React, { useEffect, useState, useRef } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { useSelector, connect } from 'react-redux';
import Topbar from './containers/Topbar';
import Customizer from './containers/index';
import LoadingScreen from './containers/common/LoadingScreen';
import AlertBox from './containers/common/AlertBox';
import Dashboard from './containers/common/Dashboard';
import Snackbar from './components/common/Snackbar';

import {
  setUserId,
  getSavedConfigsForUser,
  setSessionId,
  assignSessionDataToUser,
  loadConfig,
  savePdfToUserConfig,
  setSiteUrl,
  markOrderPlaced
} from './containers/customizer.duck';
import TermsAndConditions from './components/common/TermsAndConditions';
import ProductSelector from './containers/common/ProductSelector';
import ItemCard from './components/common/ItemCard';
import PopupOverlay from './components/common/PopupOverlay';
import { setIsLoading } from './containers/common.duck';

const mapStateToProps = ({ customizer }) => ({
  currentUserId: customizer.userId,
  siteUrl: customizer.siteUrl,
  selectedVariant: customizer.selectedVariant
});
// const analyticsDispatcher = document.createElement('p');
// analyticsDispatcher.setAttribute('id', 'analyticsDispatcher');
// const _analyticsController = new AnalyticsController(analyticsDispatcher);
const mapDispatchToProps = dispatch => ({
  setUserId: userId => {
    dispatch(setUserId(userId));
  },
  setSessionId: sessionId => {
    dispatch(setSessionId(sessionId));
  },
  getSavedConfigsForUser: (userId, type) => {
    dispatch(getSavedConfigsForUser(userId, type));
  },
  assignSessionDataToUser: (userId, sessionId) => {
    dispatch(assignSessionDataToUser(userId, sessionId));
  },
  setIsLoading: bool => {
    dispatch(setIsLoading(bool));
  },
  loadConfig: (userId, userConfigId, sessionId) => {
    dispatch(loadConfig(userId, userConfigId, sessionId));
  },
  setSiteUrl: siteUrl => {
    dispatch(setSiteUrl(siteUrl));
  }
});

const Root = () => <Redirect exact to="/helmet" />;

const App = ({
  currentUserId,
  setUserId,
  getSavedConfigsForUser,
  setSessionId,
  assignSessionDataToUser,
  setSiteUrl,
  selectedVariant,
  siteUrl,
  loadConfig
}) => {
  const { snackbar } = useSelector(state => state.common);
  const [progress, setProgress] = useState();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');

  const handleMessage = event => {
    let appType = 'helmet';
    if (location.pathname.includes('helmet')) {
      appType = 'helmet';
    } else if (location.pathname.includes('tshirt')) {
      appType = 'tshirt';
    } else if (location.pathname.includes('jackets')) {
      appType = 'jackets';
    }
    if (!event.data.type) {
      const eventData = event.data;
      if (eventData.siteUrl && eventData.siteUrl !== '') {
        // set site url for window parent.
        setSiteUrl(eventData.siteUrl);
      }
      if (eventData && eventData.sessionId) {
        if (eventData.sessionId !== '') {
          // only session id sent
          setSessionId(eventData.sessionId);
          // AnalyticsStub.onVisitor(eventData.sessionId);
        }
        if (eventData.userId && eventData.userId !== '') {
          if (eventData.event && eventData.event === 'savepdf') {
            // pdf save event
            savePdfToUserConfig(
              atob(eventData.configId),
              // atob(eventData.userId),
              eventData.userId,
              eventData.pdfUrl
            );
          } else if (eventData.event && eventData.event === 'addtocart') {
            setIsLoading(false);
          } else if (eventData.event && eventData.event === 'orderPlaced') {
            // after order is placed.
            markOrderPlaced(atob(eventData.configId), eventData.userId);
            // AnalyticsStub.onOrderPlaced(
            //   eventData.userId,
            //   atob(eventData.configId)
            // );
          } else if (eventData.configId && eventData.configId !== '') {
            // config id has been sent , we need to load this.
            setUserId(eventData.userId);
            getSavedConfigsForUser(eventData.userId, appType);
            loadConfig(
              // atob(eventData.userId),
              eventData.userId,
              atob(eventData.configId),
              eventData.sessionId
            );
          } else {
            // setUserId(atob(eventData.userId));
            // getSavedConfigsForUser(atob(eventData.userId));
            setUserId(eventData.userId);
            // AnalyticsStub.onUserSession(eventData.userId);
            getSavedConfigsForUser(eventData.userId, appType);
            if (eventData.sessionId !== '') {
              // attempt to assign session saved data to logged in user.
              assignSessionDataToUser(
                // atob(eventData.userId),
                eventData.userId,
                eventData.sessionId
              );
              // AnalyticsStub.onUserConversion(
              //   eventData.userId,
              //   eventData.sessionId
              // );
            }
          }
        }
      }
      // const eventName = event.data.event;
      // if (eventName) {
      //   switch (eventName) {
      //     case 'savepdf': {
      //       savePdfToUserConfig(
      //         atob(eventData.userId),
      //         atob(eventData.userId),
      //         eventData.pdfUrl
      //       );
      //       break;
      //     }
      //     case 'addtocart': {
      //       console.log('must close checkout popup');
      //       break;
      //     }
      //   }
      // }
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage, false);
    // _analyticsController.startListening();
    window.addEventListener('scapic-sdk-model-load-progress', data => {
      setProgress(data.detail.progress);
    });
    window.addEventListener('scapic-sdk-materials-loading-progress', data => {
      setProgress(data.detail.progress * 100);
    });
  }, []);

  useEffect(() => {
    if (location.pathname.includes('helmet')) {
      window.parent.postMessage(
        {
          module: selectedVariant === 'TShirt' ? 'tshirt' : 'helmet',
          event: 'sdk-loaded',
          configId: ''
        },
        siteUrl !== null ? siteUrl : '*'
      );
      setActiveTab('helmet');
    } else if (location.pathname.includes('tshirt')) {
      setActiveTab('tshirt');
    } else if (location.pathname.includes('jackets')) {
      setActiveTab('jacket');
    } else setActiveTab('helmet');
  }, [location.pathname]);

  useEffect(() => {
    // getSavedConfigsForUser(currentUserId, activeTab);
  }, [activeTab]);
  return (
    <div role="presentation" className="app">
      {location.pathname !== '/' && <Topbar activeTab={activeTab} />}
      <LoadingScreen progress={progress} />
      <Dashboard />
      <Snackbar text={snackbar.text} isShown={snackbar.isOpen} />
      <AlertBox />
      <Switch>
        <Route
          exact
          path="/"
          component={() => <ProductSelector activeTab={activeTab} />}
        />
        <Route exact path="/helmet" component={Customizer} />
        <Route exact path="/tshirt" component={Customizer} />
        <Route exact path="/jackets" component={Customizer} />
      </Switch>
      {/* <TermsAndConditions isLarge /> */}
    </div>
  );
};

App.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);
